import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SurflineLogo } from '@surfline/quiver-react';
import { getAccessToken } from '../../selectors/auth';
import { PerksHeader, PerksList, PerksFooter } from '../../components';
import { fetchPerkCode } from '../../redux/actions/perks';
import { getPlanType } from '../../server/utils/getPlanType';
import { navigatedToPage } from '../../redux/actions/segmentEvents';
import config from '../../config';

class Perks extends Component {
  constructor(props) {
    super(props);
    const { subscription } = this.props;
    let planType = 'free';
    if (subscription) {
      const { planId, stripePlanId } = subscription;
      if (planId) {
        planType = getPlanType(planId);
      }
      if (stripePlanId) {
        planType = getPlanType(stripePlanId);
      }
    }
    this.state = {
      planType
    };
  }
  componentDidMount() {
    this.props.doNavigatedToPage('Premium Perks');
  }
  render() {
    const {
      isCommonEligible,
      eligibleCount,
      perks,
      subscription,
      dofetchPerkCode,
      selectedPerks,
      selectedPerk,
      submitting,
      error
    } = this.props;
    const { planType } = this.state;
    return (
      <div className="perks-container">
        <div
          style={{
            backgroundImage: `url(${config.cdnHost}static/perks/bg-swelllines.svg)`,
          }}
        >
          <PerksHeader
            isCommonEligible={isCommonEligible}
            planType={planType}
            eligibleCount={eligibleCount}
            subscription={subscription}
          />
        </div>
        <div className="perks-common-container">
          <PerksList
            perks={perks}
            planType={planType}
            fetchPerkCode={dofetchPerkCode}
            selectedPerks={selectedPerks}
            selectedPerk={selectedPerk}
            submitting={submitting}
            error={error}
            subscription={subscription}
          />
        </div>
        <div className="perks-container__footer">
          <div className="perks-container__footer--logo"><SurflineLogo /></div>
          <PerksFooter />
        </div>
      </div>
    );
  }
}
Perks.propTypes = {
  isCommonEligible: PropTypes.bool,
  eligibleCount: PropTypes.number,
  perks: PropTypes.shape([]),
  subscription: PropTypes.shape({}),
  selectedPerks: PropTypes.shape([]),
  selectedPerk: PropTypes.string,
  submitting: PropTypes.bool,
  error: PropTypes.shape({}),
};
Perks.defaultProps = {
  isCommonEligible: false,
  eligibleCount: null,
  perks: null,
  subscription: null,
  selectedPerks: null,
  selectedPerk: null,
  submitting: null,
  error: null,
};

export default connect(
  state => ({
    accessToken: getAccessToken(state),
    subscription: state.subscription,
    submitting: state.interactions.submitting,
    ...state.perks
  }),
  dispatch => ({
    dofetchPerkCode: perkId => dispatch(fetchPerkCode(perkId)),
    doNavigatedToPage: name =>
      dispatch(navigatedToPage(name)),
  }),
)(Perks);

